import { render, staticRenderFns } from "./TwilioWebcam.vue?vue&type=template&id=4dd5fea2&scoped=true&"
import script from "./TwilioWebcam.vue?vue&type=script&lang=js&"
export * from "./TwilioWebcam.vue?vue&type=script&lang=js&"
import style0 from "./TwilioWebcam.vue?vue&type=style&index=0&id=4dd5fea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5fea2",
  null
  
)

export default component.exports